<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="bank_account.account_id && bank_account.account_id > 0"
                                @invoke-method="dbGetBankAccount(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="bank_account.account_id && bank_account.account_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('bank_accounts.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in bank_account_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != bank_account.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('bank_accounts.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_bank_account.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'bank_accounts' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="bank_account.status" class="ribbon ribbon-top-right" :class="`ribbon-${bank_account.status_class}`"><span class="ribbon-span">{{ bank_account.status }}</span></div>
                        <v-form ref="formBankAccount">
							<v-flex xs12>
								<v-text-field
									v-focus="bank_account_dialog"
									v-model="bank_account.account_id"
									:label="$t('lang.account_id')"
									:counter="showCounter(bank_account.account_id, 'bank_accounts.account_id')"
									:rules="ifValid('bank_accounts.account_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.account_number"
									:label="$t('lang.account_number')"
									:counter="showCounter(bank_account.account_number, 'bank_accounts.account_number')"
									:rules="ifValid('bank_accounts.account_number')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.account_name"
									:label="`${$t('lang.account_name')} *`"
									:counter="showCounter(bank_account.account_name, 'bank_accounts.account_name')"
									:rules="ifValid('bank_accounts.account_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.bank_name"
									:label="`${$t('lang.bank_name')} *`"
									:counter="showCounter(bank_account.bank_name, 'bank_accounts.bank_name')"
									:rules="ifValid('bank_accounts.bank_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.branch_name"
									:label="$t('lang.branch_name')"
									:counter="showCounter(bank_account.branch_name, 'bank_accounts.branch_name')"
									:rules="ifValid('bank_accounts.branch_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.account_type"
									:label="$t('lang.account_type')"
									:counter="showCounter(bank_account.account_type, 'bank_accounts.account_type')"
									:rules="ifValid('bank_accounts.account_type')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.routing_number"
									:label="$t('lang.routing_number')"
									:counter="showCounter(bank_account.routing_number, 'bank_accounts.routing_number')"
									:rules="ifValid('bank_accounts.routing_number')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="bank_account.currency_id"
									:label="$t('lang.currency_id')"
									:items="currencies"
									item-value="currency_id"
									item-text="currency_id"
									:rules="ifValid('bank_accounts.currency_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="bank_account.balance"
									:label="$t('lang.balance')"
									:counter="showCounter(bank_account.balance, 'bank_accounts.balance')"
									:rules="ifValid('bank_accounts.balance')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="bank_account.is_active"
									:label="$t('lang.is_active')"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('bank_accounts.is_active')"
								></bc-select>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'bank_accounts' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveBankAccounts">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_bank_account"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_bank_account')"
                :message="$t('lang.delete_bank_account_confirm')"
                @onConfirm="deleteBankAccounts()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_bank_account_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteBankAccountDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            bank_account: { },
            file_name: "",
            dbGetBankAccount: _.debounce(this.getBankAccount, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchBankAccount", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bank_account) {
                        this.bank_account = this.assignObj2(data.bank_account, this.rules_bank_accounts);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=bank_account_status&sort_by=2",
                            method: "get",
                            stateProperty: "bank_account_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "bank_accounts", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchBankAccount", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.bank_account) {
                        next((vm) => {
                            vm.bank_account = vm.assignObj2(data.bank_account, vm.rules_bank_accounts);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=bank_account_status&sort_by=2",
                                method: "get",
                                stateProperty: "bank_account_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "bank_accounts", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=bank_account_status&sort_by=2",
            method: "get",
            stateProperty: "bank_account_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_bank_accounts: (state) => state.bank_accounts.rules_bank_accounts,
            bank_account_status_options: (state) => state.settings.bank_account_status_options,
            bank_accounts: (state) => state.bank_accounts.bank_accounts,
            selectedBankAccount: (state) => state.bank_accounts.selectedBankAccount,
			currencies: (state) => state.currencies.currencies,

        }),
    },
    methods: {
        ...mapActions([
            "fetchBankAccount",
            "saveBankAccount",
            "deleteBankAccount",
            "printBankAccount",
			"fetchCurrencies",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getBankAccount(pg_refresh = false) {
            this.startLoader();

            this.fetchBankAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.bank_account) {
                    this.bank_account = this.assignObj2(data.bank_account, this.rules_bank_accounts);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printBankAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.bank_account) {
                    if (this.dev_mode) {
                        this.file_name = data.bank_account.file_name;
                    } else {
                        this.$refs.print.printReport(data.bank_account.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveBankAccounts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formBankAccount")) {
                    let body = this.prepForm(this.bank_account, this.rules_bank_accounts);

                    this.saveBankAccount({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.bank_account) {
                            this.$router.push({ name: "bank_account", params: { id: data.bank_account.account_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { account_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveBankAccounts({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.bank_account) {
                    this.bank_account = this.assignObj2(data.bank_account, this.rules_bank_accounts);
                }
            });
        },
        deleteBankAccounts() {
            this.deleteBankAccount({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "bank_accounts" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchBankAccount({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.bank_account) {
                        this.bank_account = this.assignObj2(data.bank_account, this.rules_bank_accounts);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

			if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });

        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
